import {css} from '@emotion/css';

import {Breakpoints, mq} from '../styles/js/mixins';
import {spacing} from '../styles/js/variables';

const styles = {
  richText: css`
    label: knowledgePage__richText;
    padding: ${spacing.XXS} ${spacing.XS};

    .richText {
      // this is here to handle accordions richText which is nested in richText
      padding: 0;
    }

    ${mq(Breakpoints.DESKTOP)} {
      padding: ${spacing.M} ${spacing.XS};
    }
  `,
  relatedArticles: css`
    label: knowledgePage__relatedArticles;
    margin: ${spacing.XS};

    ${mq(Breakpoints.TABLET)} {
      margin-top: ${spacing.M};
    }
  `,
};

export default styles;
